import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '@grafana/api-clients/rtkq';
import { getAPIBaseURL } from 'app/api/utils';

const BASE_URL = getAPIBaseURL('alertrulequality.alerting.grafana.app', 'v0alpha1');

export const api = createApi({
  reducerPath: 'alertRuleQualityAPIv0alpha1',
  baseQuery: createBaseQuery({
    baseURL: BASE_URL,
  }),
  tagTypes: ['AlertRuleQualityPolicy'],
  endpoints: () => ({}),
});
